import { login } from "@/api/login";
import { getToken,setToken,removeToken } from "@/util/auth";

const user = {
    state:{
        token : getToken(),
    },
    // 2.同步方法
    mutations :{
        SET_TOKEN:(state,token) =>{
            state.token = token;
        },
    },
    //3.异步调用mutations内的修改state的方法
    actions:{
        //登录
        Login({ commit },userInfo){
            const username = userInfo.username.trim();
            const password = userInfo.password;
            const code = userInfo.code;
            const uuid = userInfo.uuid;
            return new Promise((resolve,reject) =>{
                login(username, password, code ,uuid).then(res => {
                    setToken(res.data)
                    commit('SET_TOKEN', res.data)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        LogOut({commit}){
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        }
    }
}

export default user
